import React, { useState, useContext } from "react";
import styled from "styled-components";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import { planActions } from "variables/planActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomDialog from "components/CustomDialog/CustomDialog";
import EditTabContent from "./EditTabContent";
import { reclevelData, statusData } from "variables/lists/planActions";

const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
`;

export default function TabContent({ apiData, params, planActionId }) {
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;


  let data = [];
  let dataGroups = [];
  let dataSelect = [];

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  for (const [key, value] of Object.entries(apiData)) {
    if (key === "groups") {
      dataGroups.push({ label: planActions[params][key], value: value });
    } else if (key === "status" || key === "reclevel") {
      dataSelect.push({ label: planActions[params][key], value: value });
    } else {
      data.push({ label: planActions[params][key], value: value });
    }
  }

  return (
    <EditTabContent
      closeModal={handleClose}
      apiData={apiData}
      params={params}
    />
  );
}
